@import '@alfalab/core-components-vars/src/safe-area.css';
@import '../vars.css';

.component {
    flex: 1;
    width: 100%;
    max-width: 600px;
}

.content {
    @media (display-mode: standalone) {
        padding-top: var(--sat);
        padding-bottom: var(--sab);
    }
}
